import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../modules/active_modal';
import { declineBox, clearDeclineBook } from '../modules/decline_box_book';
import { addProductToCart } from '../modules/cart_actions';

class ModalDecline extends Component {

    constructor(props) {
        super(props);
        this.declineBox = this.declineBox.bind(this);
    }

    declineBox(){
        this.props.dispatch( declineBox() );
        let {declineBoxBook} = this.props;
        if(declineBoxBook && declineBoxBook.product){
            this.props.dispatch(addProductToCart(declineBoxBook.product, declineBoxBook.quantity ));
            this.props.dispatch(clearDeclineBook());
        }
    }

    render() {
        let {dispatch, declineBoxBook, tla} = this.props,
            Featured = tla === "DVD" ? "Director's": "Featured",
            message = <h3>Are you sure you want to decline the {Featured} Selections?</h3>;
        if(declineBoxBook && declineBoxBook.product)
            message = <h3>You are trying to add the {Featured} Selection <em>{declineBoxBook.product.title}</em> to your box, which will decline your automatic shipment. Are you sure you want to do this?</h3>

        return (
            <div className="modal-window login decline-fs">
                <div className={"modal-close"} onClick={() => dispatch( closeModal() )}>&times;</div>
                {message}
                <button className="btn-primary full-width" onClick={() => this.declineBox()} >Decline</button>
                <button className="btn-tertiary full-width" onClick={() => dispatch( closeModal() )}>Cancel</button>
            </div>
        );
    }
};

function mapStateToProps(state){
    return { 'declineBoxBook': state.declineBoxBook, 'tla': state.store.tla };
}

export default connect(mapStateToProps)(ModalDecline);



// WEBPACK FOOTER //
// ./src/components/ModalBoxDecline.jsx